import React, { useRef, useEffect, useState } from 'react';
import * as bootstrap from 'bootstrap';
import { Button } from 'reactstrap';

export interface PropTypes {
  open: boolean;
  title: string;
  body: string;
  cancelButtonText: string;
  confirmButtonText: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

export const Modal = React.memo(function Modal(props: PropTypes) {
  const ref = useRef();
  const [bsModal, setBsModal] = useState<bootstrap.Modal>();

  useEffect(() => {
    if (ref.current === undefined) {
      setBsModal(undefined);
      return;
    }
    setBsModal(new bootstrap.Modal(ref.current));
  }, [ref]);

  useEffect(
    () => (props.open ? bsModal?.show() : bsModal?.hide()),
    [props.open],
  );

  return (
    <div className='modal' tabIndex={-1} ref={ref}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h3 className='modal-title'>{props.title}</h3>
          </div>
          <div className='modal-body'>
            <p>{props.body}</p>
          </div>
          <div className='modal-footer'>
            <Button color='danger' onClick={props.onCancel}>
              {props.cancelButtonText}
            </Button>
            <Button color='primary' onClick={props.onConfirm}>
              {props.confirmButtonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});
